import { jsx as _jsx } from "react/jsx-runtime";
import { IconAlphabetLatin, IconBackground, IconCircle, IconLine, IconPolygon, IconShadow } from "@tabler/icons-react";
export const LayerTypeIcon = ({ type }) => {
    switch (type) {
        case "fill":
            return _jsx(IconPolygon, { size: 16, stroke: 1.5 });
        case "line":
            return _jsx(IconLine, { size: 16, stroke: 1.5 });
        case "raster":
        case "background":
            return _jsx(IconBackground, { size: 16, stroke: 1.5 });
        case "heatmap":
        case "color-relief":
        case "hillshade":
            return _jsx(IconShadow, { size: 16, stroke: 1.5 });
        case "circle":
            return _jsx(IconCircle, { size: 16, stroke: 1.5 });
        case "fill-extrusion":
        case "symbol":
            return _jsx(IconAlphabetLatin, { size: 16, stroke: 1.5 });
        default:
            throw new Error("Unknown layer type");
    }
};
